var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-page"},[(_vm.certData)?_c('jewelry-certificate',{attrs:{"item":_vm.certData}}):_c('div',{staticClass:"no-data"},[_vm._v("Sertifika verisi bulunamadı.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }